const loadDefaultTheme = (debug: boolean) =>
    import(`../themes/_variables-default.scss`).catch((err) => {
        if (debug) {
            console.error('SEARCH READY ERROR: cant load default theme');
            throw err;
        }
    });

/**
 * Load SASS theme based on given theme name
 *
 * @returns theme import promise, default theme import promise if theme is not found
 */
const loadTheme = (theme: string, debug: boolean) => {
    if (!theme) {
        return loadDefaultTheme(debug);
    }
    return import(
        /* webpackChunkName: "themes/[request]" */
        /* webpackPreload: true */
        `../themes/_variables-${theme}.scss`
    ).catch((error) => {
        if (debug) {
            console.error(`SEARCH READY ERROR: theme ${theme} loading failed`);
            console.error(error);
        }
        return loadDefaultTheme(debug);
    });
};

export default loadTheme;
